import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hideErrors, hideWarnings } from '../../actions';
import { Initializing } from '../../views';
import { AdvertiserApi } from '../../api';

class Account extends Component {
  componentDidMount() {
    this.fetchResource();
  }

  componentDidUpdate(prevProps) {
    const { pixel, account } = this.props;
    if ((!pixel?.loading && !pixel?.data?.data) || prevProps?.account?.uuid !== account?.uuid) {
      this.fetchResource();
    }
  }

  fetchResource() {
    const { account, dispatch } = this.props;
    if (account) {
      dispatch(AdvertiserApi.actions.pixel.get({ account_id: account.uuid }));
    }
  }

  setErrors(customer) {
    const { slug } = this.props;
    const errors = [];

    if (customer?.default_source === null) {
      errors.push(
        <span>
          You have yet to add a payment method, please add a credit card to this account in the
          <Link to={slug && `/advertiser/home/accounts/${slug}/cards`}> payment options section</Link>.
        </span>,
      );
    }
    if (customer?.default_source !== null && (customer?.outstanding_balance > 0 || customer?.subscription_status !== 'active')) {
      errors.push(
        <span>
          A billing attempt has failed, <Link to={slug && `/advertiser/home/accounts/${slug}/cards`}> verify your card </Link>
          and <Link to={slug && `/advertiser/home/accounts/${slug}/invoices`}> pay the overdue invoices </Link>
          before creating new campaigns.
        </span>,
      );
    }

    return errors;
  }

  closeErrors = () => {
    const { dispatch, slug } = this.props;
    dispatch(hideErrors(slug));
  };

  closeWarnings = () => {
    const { dispatch, slug } = this.props;
    dispatch(hideWarnings(slug));
  };

  render() {
    const { user, accounts, account, customer, isLoading, showErrors } = this.props;
    const errors = this.setErrors(customer);

    if (isLoading) {
      return <Initializing />;
    }

    if (accounts?.data?.data !== undefined && account === undefined) {
      return (
        <div className="middle-box text-center animated fadeIn">
          <h1>404</h1>
          <h3 className="font-bold">Page Not Found</h3>
          <div className="error-desc">Sorry, but this account does not exist.</div>
        </div>
      );
    }

    return (
      <div>
        {!user?.isCustomdash && errors.length > 0 && showErrors && (
          <div className="alert alert-danger" style={{ padding: '15px' }}>
            <span className={'pull-right'} style={{ cursor: 'pointer' }} onClick={this.closeErrors}>
              <FontAwesomeIcon icon="times-circle" />
            </span>
            <span>The following issue(s) will prevent your campaigns from running:</span>
            <ul style={{ marginTop: '5px' }}>
              {errors.map((error, i) => (
                <li style={{ paddingLeft: '10px' }} key={i}>
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    params: { accountSlug },
  } = ownProps;
  const {
    advertiser: { accounts, customers, invoices, pixel },
    user,
    settings,
  } = state;
  const account = accounts?.data?.data?.find(w => w.slug === accountSlug);
  const customer = customers?.data?.data?.find(w => w.advertiser_account_uuid === account?.uuid) || {};
  const showErrors = settings?.hideErrors?.includes(accountSlug) ? false : true;
  const showWarnings = settings?.hideWarnings?.includes(accountSlug) ? false : true;

  return {
    user: user.data,
    slug: accountSlug,
    account,
    isLoading: accounts.loading,
    customer,
    customers,
    invoices,
    showErrors,
    showWarnings,
    accounts,
    pixel,
  };
};

export default connect(mapStateToProps)(Account);
